import fetch from '@adc/fetch'
import configment from '@adc/configment'
import { seekTypes } from '@adc/seek'
import { seekThroughGraph } from './utils'

const getVenues = async (req, fetchOptions) => {
  fetchOptions.fields = fetchOptions.fields.map(field =>
    field === 'listing_count'
      ? 'listing_count(aggregationCategory: SCHEDULED)'
      : field
  )

  return seekThroughGraph(req, fetchOptions, seekTypes.VENUES)
}

const postVenue = async (req, values) => {
  const res = await fetch(
    `${configment.get('RESI_MS_VENUE')}/resi/venue/v1/venues`,
    {
      req,
      method: 'POST',
      body: values,
    }
  )
  return res.body
}

const bulkUpdateVenue = async (req, values) => {
  const res = await fetch(
    `${configment.get('RESI_MS_VENUE')}/resi/venue/v1/venues/bulk`,
    {
      req,
      method: 'PATCH',
      body: values,
    }
  )
  return res.body
}

const getVenue = async (req, id) => {
  const res = await fetch(
    `${configment.get('RESI_MS_VENUE')}/resi/venue/v1/venues/${id}`,
    {
      req,
    }
  )
  return res.body
}

const putVenue = async (req, values) => {
  const res = await fetch(
    `${configment.get('RESI_MS_VENUE')}/resi/venue/v1/venues/${
      values.venue_id
    }`,
    {
      req,
      method: 'PUT',
      body: values,
    }
  )
  return res.body
}

const getVenuesSuggestions = async (req, fetchOptions) => {
  const res = await fetch(
    `${configment.get('RESI_CS_SEEK')}/resi/seek/v1/venues/suggest`,
    {
      req,
      method: 'POST',
      body: fetchOptions,
    }
  )
  return res.body
}

export {
  bulkUpdateVenue,
  getVenues,
  postVenue,
  getVenue,
  putVenue,
  getVenuesSuggestions,
}
